import { render, staticRenderFns } from "./Colmenares.vue?vue&type=template&id=617aa9e8&scoped=true&"
import script from "./Colmenares.vue?vue&type=script&lang=js&"
export * from "./Colmenares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617aa9e8",
  null
  
)

export default component.exports